import { DocumentNode, useMutation } from '@apollo/client';

import { graphql } from '../gql';
import { GET_RESERVES } from './reserves.query';

export const REOPEN_CLAIM = graphql(`
  mutation reopenClaim($claimUuid: String!) {
    reopenClaim(claimUuid: $claimUuid) {
      uuid
      referenceId
      status
      reopenedDate
    }
  }
`);

export interface ReopenClaimInput {
  claimUuid: string;
}

export function useReopenClaimMutation() {
  const [reopenClaimMutation, { loading, error }] = useMutation(
    REOPEN_CLAIM as unknown as DocumentNode,
    {
      refetchQueries: [GET_RESERVES, 'getClaimInformation'],
      awaitRefetchQueries: true,
    }
  );

  const reopenClaim = async (claimInput: ReopenClaimInput) => {
    const response = await reopenClaimMutation({
      variables: {
        claimUuid: claimInput.claimUuid,
      },
    });
    return response.data?.reopenClaim;
  };

  return {
    reopenClaim,
    loading,
    error,
  };
}
